import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const WelcomeEmailDrip = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12729"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12729)">
          <rect
            x="-2"
            y="-2"
            width="120"
            height="114"
            rx="4.69632"
            fill="#ECF2FF"
          />
          <g clipPath="url(#clip0_1529_12729)">
            <path
              d="M26.3381 18.3274L11.9065 21.0988C11.5238 21.1723 11.1859 21.3949 10.9672 21.7175C10.7486 22.0401 10.667 22.4364 10.7405 22.8191L12.6805 32.9212C12.754 33.304 12.9766 33.6419 13.2992 33.8605C13.6218 34.0792 14.0181 34.1608 14.4008 34.0873L28.8324 31.3158C29.2152 31.2423 29.553 31.0198 29.7717 30.6972C29.9904 30.3746 30.0719 29.9783 29.9984 29.5955L28.0584 19.4934C27.9849 19.1107 27.7624 18.7728 27.4398 18.5541C27.1171 18.3355 26.7209 18.2539 26.3381 18.3274Z"
              fill="#E3E3E3"
            />
            <path
              d="M11.9065 21.0988C11.5238 21.1723 11.1859 21.3949 10.9672 21.7175C10.7486 22.0401 10.667 22.4364 10.7405 22.8191L12.6805 32.9212C12.754 33.304 12.9766 33.6419 13.2992 33.8605C13.6218 34.0792 14.0181 34.1608 14.4008 34.0873L15.5929 33.8583L26.087 18.3756L11.9065 21.0988Z"
              fill="white"
            />
            <path
              d="M26.3381 18.3274L11.9065 21.0988C11.5238 21.1723 11.1859 21.3949 10.9672 21.7175C10.7486 22.0401 10.667 22.4364 10.7405 22.8191L12.6805 32.9212C12.754 33.304 12.9766 33.6419 13.2992 33.8605C13.6218 34.0792 14.0181 34.1608 14.4008 34.0873L28.8324 31.3158C29.2152 31.2423 29.553 31.0198 29.7717 30.6972C29.9904 30.3746 30.0719 29.9783 29.9984 29.5955L28.0584 19.4934C27.9849 19.1107 27.7624 18.7728 27.4398 18.5541C27.1171 18.3355 26.7209 18.2539 26.3381 18.3274Z"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.0181 21.6463L19.3789 25.724C19.6647 25.8634 19.9879 25.9063 20.3002 25.8463C20.6125 25.7864 20.8968 25.6267 21.1107 25.3914L27.3657 18.504"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M23.0024 39.9172L25.4967 52.9057"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.1187 37.8625L20.0587 47.9647"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M26.7773 36.1997L28.7173 46.3018"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g clipPath="url(#clip1_1529_12729)">
            <path
              d="M103.148 27.561L87.578 22.3307C87.165 22.1919 86.7139 22.2229 86.3238 22.4168C85.9338 22.6107 85.6367 22.9517 85.498 23.3646L81.8367 34.2635C81.698 34.6765 81.729 35.1276 81.9229 35.5177C82.1168 35.9078 82.4577 36.2048 82.8707 36.3436L98.4405 41.5739C98.8535 41.7126 99.3046 41.6816 99.6947 41.4877C100.085 41.2938 100.382 40.9529 100.521 40.54L104.182 29.6411C104.321 29.2281 104.29 28.777 104.096 28.3869C103.902 27.9968 103.561 27.6997 103.148 27.561Z"
              fill="#E3E3E3"
            />
            <path
              d="M87.578 22.3307C87.165 22.1919 86.7139 22.2229 86.3238 22.4168C85.9338 22.6107 85.6367 22.9517 85.498 23.3646L81.8367 34.2635C81.698 34.6765 81.729 35.1276 81.9229 35.5177C82.1168 35.9078 82.4577 36.2048 82.8707 36.3436L84.1567 36.7756L102.877 27.47L87.578 22.3307Z"
              fill="white"
            />
            <path
              d="M103.148 27.561L87.578 22.3307C87.165 22.1919 86.7139 22.2229 86.3238 22.4168C85.9338 22.6107 85.6367 22.9517 85.498 23.3646L81.8367 34.2635C81.698 34.6765 81.729 35.1276 81.9229 35.5177C82.1168 35.9078 82.4577 36.2048 82.8707 36.3436L98.4405 41.5739C98.8535 41.7126 99.3046 41.6816 99.6947 41.4877C100.085 41.2938 100.382 40.9529 100.521 40.54L104.182 29.6411C104.321 29.2281 104.29 28.777 104.096 28.3869C103.902 27.9968 103.561 27.6997 103.148 27.561Z"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M86.4125 22.376L92.3106 30.9381C92.5122 31.2308 92.8033 31.4502 93.1402 31.5634C93.4771 31.6765 93.8416 31.6774 94.179 31.5658L104.051 28.2979"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M88.0405 46.7439L83.3332 60.7568"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M84.4155 42.0607L80.7543 52.9596"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M93.7578 45.199L90.0966 56.0979"
              stroke="#191919"
              strokeWidth="0.918461"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M38.1271 58.7631V70.2835L29.625 64.6083L38.1271 58.7631Z"
            fill="#66E1FF"
          />
          <path
            d="M78.5119 64.6083L70.0098 70.2835V58.7631L78.5119 64.6083Z"
            fill="#66E1FF"
          />
          <path
            d="M78.5123 64.6083V86.9264C78.5123 87.772 78.1764 88.583 77.5785 89.1809C76.9806 89.7788 76.1696 90.1147 75.324 90.1147H32.8133C31.9677 90.1147 31.1568 89.7788 30.5588 89.1809C29.9609 88.583 29.625 87.772 29.625 86.9264V64.6083L38.1271 70.2835L46.1404 75.6186L46.6293 75.236H61.508L61.9969 75.6186L70.0102 70.2835L78.5123 64.6083Z"
            fill="#C2F3FF"
          />
          <path
            d="M70.01 43.3527V70.2833L61.9967 75.6184L61.5079 75.2358H46.6291L46.1402 75.6184L38.127 70.2833V43.3527C38.127 42.789 38.3509 42.2483 38.7495 41.8497C39.1481 41.4511 39.6888 41.2272 40.2525 41.2272H67.8845C68.4482 41.2272 68.9888 41.4511 69.3874 41.8497C69.7861 42.2483 70.01 42.789 70.01 43.3527Z"
            fill="#E3E3E3"
          />
          <path
            d="M67.8845 41.2272H40.2525C39.6888 41.2272 39.1481 41.4511 38.7495 41.8497C38.3509 42.2483 38.127 42.789 38.127 43.3527V70.2832L39.1557 70.9677L68.7198 41.4015C68.4562 41.2869 68.1719 41.2276 67.8845 41.2272Z"
            fill="white"
          />
          <path
            d="M70.0102 58.7631L78.5123 64.6083V86.9264C78.5123 87.772 78.1764 88.583 77.5785 89.1809C76.9806 89.7788 76.1696 90.1147 75.324 90.1147H32.8133C31.9677 90.1147 31.1568 89.7788 30.5588 89.1809C29.9609 88.583 29.625 87.772 29.625 86.9264V64.6083L38.1271 58.7631"
            stroke="#191919"
            strokeWidth="0.918461"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36.0015 83.7382L46.6291 75.2361H61.5079L72.1356 83.7382"
            stroke="#191919"
            strokeWidth="0.918461"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M78.512 64.6083L65.7588 73.1104"
            stroke="#191919"
            strokeWidth="0.918461"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.625 64.6083L42.3782 73.1104"
            stroke="#191919"
            strokeWidth="0.918461"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M70.01 70.2769V43.3527C70.01 42.789 69.7861 42.2483 69.3874 41.8497C68.9888 41.4511 68.4482 41.2272 67.8845 41.2272H40.2525C39.6888 41.2272 39.1481 41.4511 38.7495 41.8497C38.3509 42.2483 38.127 42.789 38.127 43.3527V70.2769"
            stroke="#191919"
            strokeWidth="0.918461"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.0012 58.0685C48.5851 57.6524 47.8914 57.6524 47.4059 58.0685C46.9897 58.4847 46.9897 59.1784 47.4059 59.6639L53.3711 65.6291C54.0648 66.3227 55.0358 66.7389 56.0763 66.7389C57.1167 66.7389 58.0878 66.3227 58.7814 65.6291L60.3074 64.1031C61.3479 63.0627 61.8334 61.5367 61.556 60.0801L60.5849 55.294C60.5155 54.8085 60.1687 54.4617 59.6832 54.3923C59.0589 54.2536 58.3653 54.7391 58.2959 55.3634L58.0184 57.6524L52.8856 52.5195C52.4694 52.1034 51.7757 52.1034 51.2902 52.5195C50.874 52.9357 50.874 53.6293 51.2902 54.1149L50.5966 53.3519C50.1804 52.9357 49.4868 52.9357 49.0012 53.3519C48.5851 53.7681 48.5851 54.4617 49.0012 54.9472L49.7642 55.7102C49.348 55.294 48.6544 55.294 48.1689 55.7102C47.7527 56.1264 47.7527 56.82 48.1689 57.3056L49.0012 58.0685Z"
            fill="#F8ECDF"
            stroke="black"
            strokeWidth="0.918461"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.2891 54.1122L54.4104 57.2335"
            stroke="black"
            strokeWidth="0.918461"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.7642 55.7103L52.9549 58.8317"
            stroke="black"
            strokeWidth="0.918461"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.3593 60.4269L49.001 58.0686"
            stroke="black"
            strokeWidth="0.918461"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.1167 52.8662C57.3936 52.8662 57.6013 52.9354 57.809 53.0739"
            stroke="black"
            strokeWidth="0.918461"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.4634 51.1323C58.2264 51.1323 58.92 51.4098 59.4055 51.9647"
            stroke="black"
            strokeWidth="0.918461"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M48.2383 63.6177C48.2383 64.3802 48.8621 65.004 49.6247 65.004"
            stroke="black"
            strokeWidth="0.918461"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M46.5039 63.9646C46.5039 65.4906 47.7524 66.7391 49.2784 66.7391"
            stroke="black"
            strokeWidth="0.918461"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1529_12729">
            <rect
              width="36.4064"
              height="36.4064"
              fill="white"
              transform="translate(1 21.8661) rotate(-10.8707)"
            />
          </clipPath>
          <clipPath id="clip1_1529_12729">
            <rect
              width="40.6914"
              height="40.6914"
              fill="white"
              transform="translate(76.5405 17.0861) rotate(18.5687)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
